import { LOCATION_CHANGE } from 'redux-first-history';
import virtualPageView from './virtual-page-view';

export default {
  [LOCATION_CHANGE]: virtualPageView,
};
